import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from '@angular/fire/firestore';

import { PublishedMatch } from '../../models';
import { Subject } from 'rxjs/Subject';
import { BaseService } from './base-dataservice';

@Injectable()
export class PublishedMatchService extends BaseService<PublishedMatch> {
  constructor(afs: AngularFirestore) {
    super('published-matches', afs);
  }

  //////  SPECIFIC SERVICE METHODS

  getByMatchId(matchId: string): Observable<PublishedMatch> {
    const subject = new Subject<PublishedMatch>();

    console.info('[PublishedMatchService] getByMatchId ', matchId);
    const coll = this.afs.collection(this.uri, ref => ref.where('sourceMatchId', '==', matchId));

    coll.snapshotChanges().subscribe(changes => {
      changes.map(a => {
        const data = a.payload.doc.data() as PublishedMatch;
        data.id = a.payload.doc.id;
        subject.next(data);
      });
    });

    return subject.asObservable();
  }

  removePublishedMatch(matchId: string): void {
    const coll = this.afs.collection(this.uri, ref => ref.where('sourceMatchId', '==', matchId));

    console.info('[PublishedMatchService] attempting unpublish: ', matchId);

    const subscription = coll.snapshotChanges().subscribe(changes => {
      changes.map(docAction => {
        if (docAction.payload.doc.exists) {

          console.info(
            '[PublishedMatchService] unpublishMatch - removing: ',
            docAction.payload.doc.id
          );
          const docRef = coll.doc(docAction.payload.doc.id);
          docRef.delete();
          subscription.unsubscribe();
        } else {
          console.warn(
            '[PublishedMatchService] unpublishMatch - unable to remove: ',
            docAction.payload.doc
          );
        }
      });
    });
  }
}
